<section class="page">
  <header class="page-header">
    <h2>Créer une nomenclature</h2>
  </header>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  <form (ngSubmit)="submit()" class="panel">
    <label for="numero">Numéro de nomenclature *</label>
    <input id="numero" type="number" [(ngModel)]="numeroNomenclature" name="numeroNomenclature" required max="999999999" />

    <label for="nom">Nom de la nomenclature *</label>
    <input id="nom" type="text" [(ngModel)]="nom" name="nom" required maxlength="255" />

    <label for="source-nomenclature">Dupliquer une nomenclature existante</label>
    <select id="source-nomenclature" [(ngModel)]="sourceNomenclatureId" name="sourceNomenclatureId">
      <option value="">-- aucune duplication --</option>
      @for (nomenclature of nomenclatures; track nomenclature.id) {
        <option [value]="nomenclature.id">N° {{ nomenclature.numero_nomenclature }} - {{ nomenclature.nom }}</option>
      }
    </select>
    @if (loadingNomenclatures) {
      <p>Chargement des nomenclatures existantes...</p>
    }

    <label for="date">Date de création</label>
    <input id="date" type="date" [(ngModel)]="dateCreation" name="dateCreation" />

    <button type="submit" [disabled]="loading">{{ loading ? 'Création...' : 'Créer' }}</button>
  </form>
</section>
